import React, { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { ADM, GFE, GFO, GFE_CONSULTA, GFO_CONSULTA } from '~/constants/perfil';

import { UnidataTable, Modal } from '~/components';
import { number } from '~/helpers';
import {
  findOperacaoCotaDistribUnidade,
  recordFiltering,
} from '~/store/modules/operacaocotadistribunidade/actions';
import { Visibility } from '@material-ui/icons';

import DetalheJustificativa from './DetalheJustificativa';

function OperacaoCotaDistribUnidade() {
  const { profile } = useSelector((state) => state.user);

  const modalJusRef = useRef(null)

  const operacaocotadistribunidade = useSelector(
    (state) => state.operacaocotadistribunidade
  );

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.glousuariotipo) {
        case ADM:
        case GFE:
        case GFO:
        case GFE_CONSULTA:
        case GFO_CONSULTA:
          break;
        default:
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const header = useMemo(
    () => [
      {
        id: 'orga_codigo',
        label: 'Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'orga_nome',
        label: 'Descrição Órgão',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'unid_codigo',
        label: 'Unidade',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'unid_nome',
        label: 'Descrição Unidade',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'prod_descricao',
        label: 'Produto',
        filter: {
          type: 'text',
        },
        align: 'left',
      },

      {
        id: 'coun_cota',
        label: 'Cota',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'coun_saldo',
        label: 'Saldo',
        align: 'right',
        formatted: (value) => number(value, 1),
        precision: '1',
      },
      {
        id: 'coun_justificativa',
        label: 'Justificativa',
        formatted: (value) => value && value.length > 10 ? value.substring(0, 5) + '...' : value,
      }

    ],
    []
  );

  const buttons = useMemo(() => [
    {

      title: 'Visualizar Justificativa',
      action: (value) => modalJusRef.current.handleOpenModal({ data: value }),
      icon: <Visibility />,
    }

  ], [])

  const actionsModalObs = useMemo(() => [{
    label: 'Fechar',
    color: 'secondary',
    callback: () => modalJusRef.current.handleCloseModal(),
  }], [modalJusRef])

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="orga_codigo, unid_codigo  ASC"
        create={false}
        delete={false}
        update={false}
        title={'Visualizar Cota Unidade'}
        fixed
        header={header}
        find={findOperacaoCotaDistribUnidade}
        redux={operacaocotadistribunidade}
        read={recordFiltering}
        actions={buttons}
        detach="orga_nome"
        keys={['orga_codigo', 'unid_codigo']}
        view="VW_COTA_UNIDADE"
        reportTitle="Visualizar Cota Unidade"
      />
      <Modal
        ref={modalJusRef}
        component={DetalheJustificativa}
        title="Justificativa"
        maxWidth="sm"
        actions={actionsModalObs}
      />
    </>
  );
}

export default OperacaoCotaDistribUnidade;
